/**
 * Container for a fileupload component
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import fileApiSupport from './fileApiSupport';
import { showBroadcast } from '../../actions/globalBroadcastActions';
import { connect } from 'react-redux';

class FileUpload extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        onFileSubmit: PropTypes.func.isRequired,
        classes: PropTypes.string,
        multiple: PropTypes.bool,
        inProgress: PropTypes.bool.isRequired,
    };

    showNotSupportWarning() {
        const message =
            'Vi klarte ikke å laste opp fila. PS! Filopplasting krever Chrome, Firefox, Opera, IE10 eller nyere.';
        this.props.dispatch(showBroadcast(message));
    }

    onFileChange(e) {
        if (!fileApiSupport()) {
            return this.showNotSupportWarning();
        }

        const files = e.target.files;

        if (files && files.length) {
            const args = this.props.multiple ? files : files[0];
            this.props.onFileSubmit(args);
            e.target.value = '';
        }
    }

    render() {
        const classes = classnames(this.props.classes, 'file-input-button', {
            'button--in-progress': !!this.props.inProgress,
            'button---is-disabled': !!this.props.inProgress,
        });

        return (
            <label className={classes} role="button" tabIndex="0">
                {this.props.children}
                <input
                    accept="image/jpeg, image/png, image/gif"
                    aria-hidden="true"
                    autoComplete="off"
                    data-profile-image-input=""
                    multiple={this.props.multiple}
                    name="files"
                    onChange={this.onFileChange.bind(this)}
                    ref="input"
                    tabIndex="-1"
                    type="file"
                />
            </label>
        );
    }
}

export default connect()(FileUpload);
